import React, { useEffect, useState } from "react";
import CustomTable from "../../../components/main_comps/custom_table";
import {
  VanTransactionHeader,
  VanTransactionHeaders,
} from "../../../../utility/TableHeaders";
import {
  fetchTransactionList,
  fetchVanTransaction,
} from "../../../../services/fetchListingData";
import {
  CLIENT,
  TRANSACTION_CREDITED,
  TRANSACTION_DEBITED,
  TRANSACTION_DEEMED,
  TRANSACTION_FAIL,
  TRANSACTION_FAILED,
  TRANSACTION_PENDING,
  TRANSACTION_REFUND,
  TRANSACTION_REJECTED,
  TRASACTION_FAILURE,
} from "../../../../utility/constants/valueConstants";
import { CustomViewModal } from "../../../components/main_comps/custom_modal/CustomViewModal";
import CustomModal from "../../../components/main_comps/custom_modal";
import { useDispatch, useSelector } from "react-redux";
import {
  SS_ROLE,
  SS_USER_HASH_ID,
} from "../../../../utility/constants/secureStorageManager";
import { setHeaders } from "../../../../services/aclValidateServiceTable";
import moment from "moment";
import secureStorage from "../../../../services/secureStorage";
import { formatBalance } from "../../../../utility/moneyFormatter";

const VanTransaction = ({ currentTab, selectedService }) => {
  const dispatch = useDispatch();
  const vanTransaction = useSelector(
    (state) => state.listingSlice.vanTransactionList
  );
  const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [viewMoreData, setViewMoreData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [dataForModal, setDataForModal] = useState({});
  const vanList = useSelector((state) => state.listingSlice.vanDetails);
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const filters = useSelector((state) => state.globalFiltersSlice);
  const role = secureStorage.getItem(SS_ROLE);
  const [clientDetails, setClientDetials] = useState({});
  useEffect(() => {
    let data = {
      // "transfer_timestamp:": moment(viewMoreData?.transferTimestamp).format(
      //   "DD/MM/YYYY HH:mm A" || "N/A"
      // ),
      "Bank UTR": viewMoreData?.bankUtr || "N/A",
      "NK UTR": viewMoreData?.transferUniqueNo || "N/A",
      VAN: viewMoreData?.bene_account_no || "N/A",
      Bene_account_ifsc: viewMoreData?.bene_account_ifsc || "N/A",
      "Transaction Type": viewMoreData?.transfer_type || "N/A",
      Transfer_amt: viewMoreData?.actual_amount || "N/A",
      Final_amount:
        viewMoreData["status"] === TRANSACTION_CREDITED ||
        viewMoreData["status"] === TRANSACTION_DEBITED ||
        viewMoreData["status"] === TRANSACTION_DEEMED ||
        viewMoreData["status"] === TRANSACTION_REFUND ||
        viewMoreData["status"] === TRANSACTION_FAILED ||
        viewMoreData["status"] === TRANSACTION_FAIL ||
        viewMoreData["status"] === TRASACTION_FAILURE ||
        viewMoreData["status"] === TRANSACTION_PENDING ||
        viewMoreData["status"] === TRANSACTION_REJECTED
          ? "Rs " + formatBalance(Number(viewMoreData?.final_amount))
          : "Rs 0",
      Commission_amount:
        viewMoreData["status"] === TRANSACTION_CREDITED ||
        viewMoreData["status"] === TRANSACTION_DEBITED ||
        viewMoreData["status"] === TRANSACTION_DEEMED
          ? "Rs " + formatBalance(Number(viewMoreData?.commissionAmount))
          : "Rs 0",
      Commission_Gst:
        viewMoreData["status"] === TRANSACTION_CREDITED ||
        viewMoreData["status"] === TRANSACTION_DEBITED ||
        viewMoreData["status"] === TRANSACTION_DEEMED
          ? "Rs " + formatBalance(Number(viewMoreData?.commissionGst))
          : "Rs 0",

      rmtr_account_no: viewMoreData?.rmtr_account_no || "N/A",
      rmtr_account_ifsc: viewMoreData?.rmtr_account_ifsc || "N/A",
      rmtr_full_name: viewMoreData?.rmtr_full_name || "N/A",
      reference_id: viewMoreData?.referenceId || "N/A",
      Status:
        viewMoreData?.status === TRANSACTION_CREDITED ||
        viewMoreData?.status === TRANSACTION_DEBITED ||
        viewMoreData?.status === TRANSACTION_REFUND
          ? "Success"
          : viewMoreData?.status === TRANSACTION_FAILED ||
            viewMoreData?.status === TRANSACTION_FAIL ||
            viewMoreData?.status === TRASACTION_FAILURE
          ? "Failed"
          : viewMoreData?.status === TRANSACTION_PENDING
          ? "Initiated"
          : viewMoreData?.status === TRANSACTION_DEEMED
          ? "Deemed"
          : viewMoreData?.status === TRANSACTION_REJECTED
          ? "Rejected"
          : "",
      "Credited time":
        moment(viewMoreData?.created_at).format("DD/MM/YYYY HH:mm A") || "N/A",
      "Modified Date": moment(viewMoreData?.modified_at).format(
        "DD/MM/YYYY HH:mm A"
      ),
    };
    setDataForModal({ ...data });
  }, [viewMoreData]);

  const setHeaders = (data, role) => {
    let arr = [];

    data &&
      data?.map((val, i) => {
        if (val?.roles) {
          if (val?.roles?.includes(role))
            arr.push({
              title: val?.title,
              key: val?.key,
            });
        } else {
          arr.push({
            title: val?.title,
            key: val?.key,
          });
        }
      });
    return arr;
  };

  const getClientProgram = () => {
    let van = clientSecret.filter((obj) => obj.serviceType === "van");
    if (van.length > 0) {
      setClientDetials(van[0]);
    }
  };

  useEffect(() => {
    if (role === CLIENT) {
      getClientProgram();
    }
  }, []);
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 15);
  const defaultDateRange = `${("0" + startDate.getDate()).slice(-2)}/${(
    "0" +
    (startDate.getMonth() + 1)
  ).slice(-2)}/${startDate.getFullYear()}-${("0" + endDate.getDate()).slice(
    -2
  )}/${("0" + (endDate.getMonth() + 1)).slice(-2)}/${endDate.getFullYear()}`;

  useEffect(() => {
    dispatch(
      fetchTransactionList({
        dateRange:
          filters?.fromDate && filters?.toDate
            ? moment(filters?.fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(filters?.toDate).format("DD/MM/YYYY")
            : defaultDateRange,
        page: 0,
        size: 10,
        resellerId: filters?.resellerId?.value,
        clientId: filters?.clientId?.value,
        status: filters?.status ? filters?.status.value : "",
        serviceType: "van",
        custRefNo: filters?.custRefNo ?? "",
        transactionId: filters?.transactionId ?? "",
        serviceProviderName:
          role === CLIENT
            ? clientDetails?.serviceProviderName
            : selectedService,
        van: filters?.van ?? "",
      })
    );
  }, [selectedService]);

  return (
    <div style={{ padding: "0px 10px", overflow: "hidden" }}>
      <CustomTable
        data={vanTransaction?.transactions}
        currentPage={vanTransaction?.currentPageNo - 1}
        headers={setHeaders(VanTransactionHeader, role)}
        totalElements={vanTransaction?.totalRecords}
        totalPages={vanTransaction?.totalPages}
        handlePaginate={(page) => {
          setCurrentPage(page);
          dispatch(
            fetchTransactionList({
              dateRange:
                filters?.fromDate && filters?.toDate
                  ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(filters?.toDate).format("DD/MM/YYYY")
                  : "",
              page: page + 1,
              size: 10,
              resellerId: filters?.resellerId?.value,
              clientId: filters?.clientId?.value,
              status: filters?.status ? filters?.status.value : "",
              serviceType: "van",
              custRefNo: filters?.custRefNo ?? "",
              transactionId: filters?.transactionId ?? "",
              serviceProviderName:
                role === CLIENT
                  ? clientDetails?.serviceProviderName
                  : selectedService,
              van: filters?.van ?? "",
            })
          );
        }}
        onViewMore={(row) => {
          setViewMoreModal(true);
          setViewMoreData(row);
        }}
      />
      {viewMoreModal && (
        <CustomModal
          open={viewMoreModal}
          onClose={() => {
            setViewMoreModal(false);
            // setDataForModal({});
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "100%",
            borderRadius: "20px 0px 0px 20px",
          }}
          viewMoreStyle={{
            justifyContent: "flex-end",
          }}
          isHeaderRequired={false}
        >
          <CustomViewModal
            data={dataForModal}
            closeModal={() => {
              setViewMoreModal(false);
              // setDataForModal({});
            }}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default VanTransaction;
